import { message } from "antd";
// import * as XLSX from "xlsx";
import axios from "axios";
import authAction from "@iso/redux/auth/actions";
import { store } from "../../redux/store";
import Swal from "sweetalert2";

const { logout } = authAction;
const StolleAxios = axios.create();

export const redemptionType = {
  1: "Earn",
  2: "Redeemed",
  3: "Extra",
};
export const transactionType = {
  1: "Referral bonus",
  2: "Developement bonus",
  3: "Monthly salary",
  4: "Stored value",
  5: "Withdrawal",
  6: "Access",
  7: "Transfer",
  8: "Allowance To eWallet",
  9: "Handling fee",
  0: "Withholding Tax 2%",
  10: "Monthly Rewards Bonus",
  11: "Credit - Other Bonus",
};

export const jobAbbrev = [
  { abbrev: "M", job: "10" },
  { abbrev: "AM", job: "20" },
  { abbrev: "QM", job: "30" },
  { abbrev: "R", job: "40" },
  { abbrev: "G", job: "50" },
  { abbrev: "D", job: "60" },
  { abbrev: "BD", job: "70" },
  { abbrev: "PD", job: "80" },
  { abbrev: "CD", job: "90" },
];

export const getGoodNameModel = (str = "") => {
  let sp = str.split("(");
  return sp.length > 1 ? [sp[0].replace(")", ""), sp[1].replace(")", "")] : [str, ""];
};

export const base64photoPath = (base64) => (!!base64 ? "data:image/png;base64," + base64 : base64);

export function StolleAPIDelete(httpPostPath = "", configs = {}) {
  return new Promise((resolve, reject) => {
    if (!httpPostPath) reject("Invalid Path: " + httpPostPath);
    StolleAxios.delete(process.env.REACT_APP_API_DOMAIN + httpPostPath, { ...configs })
      .then((response) => {
        const { responseCode, ...restData } = response.data;

        switch (responseCode) {
          case "S001":
            resolve({ code: responseCode, data: restData });
            break;
          case "E001":
            reject({ code: responseCode });
            forceLogout();
            break;
          default:
            console.log(response);
            reject({ code: responseCode, message: ErrorMessage.errorDictionary[responseCode] });
        }
      })
      .catch((err) => {
        console.log({ ...err });
        const { response } = err;

        if (!!response) {
          message.error(response?.status + " : " + ErrorMessage.errorDictionary[response?.data?.responseCode]);
          reject(err);
        } else {
          forceLogout();
        }
      });
  });
}
export function StolleAPIPut(httpPostPath = "", body, configs = {}) {
  return new Promise((resolve, reject) => {
    if (!httpPostPath) reject("Invalid Path: " + httpPostPath);
    StolleAxios.put(process.env.REACT_APP_API_DOMAIN + httpPostPath, body, { ...configs })
      .then((response) => {
        const { responseCode, ...restData } = response.data;

        switch (responseCode) {
          case "S001":
            resolve({ code: responseCode, data: restData });
            break;
          case "E001":
            reject({ code: responseCode });
            forceLogout();
            break;
          default:
            console.log(response);
            reject({ code: responseCode, message: ErrorMessage.errorDictionary[responseCode] });
        }
      })
      .catch((err) => {
        console.log({ ...err });
        const { response } = err;

        if (!!response) {
          message.error(response?.status + " : " + ErrorMessage.errorDictionary[response?.data?.responseCode]);
          reject(err);
        } else {
          forceLogout();
        }
      });
  });
}
export function StolleAPIPost(httpPostPath = "", body, configs = {}, domainPath = process.env.REACT_APP_API_DOMAIN) {
  return new Promise((resolve, reject) => {
    if (!httpPostPath) reject("Invalid Path: " + httpPostPath);
    StolleAxios.post(domainPath + httpPostPath, body, { ...configs })
      .then((response) => {
        const { responseCode, ...restData } = response.data;

        switch (responseCode) {
          case "S001":
          case "S002":
            resolve({ code: responseCode, data: restData });
            break;
          case "E001":
            reject({ code: responseCode });
            forceLogout();
            break;
          case "E999":
            console.log(response);
            reject({ code: responseCode, message: restData?.message });
            break;
          default:
            console.log(response);
            reject({ code: responseCode, message: ErrorMessage.errorDictionary[responseCode] });
        }
      })
      .catch((err) => {
        console.log({ ...err });
        const { response } = err;

        if (!!response) {
          message.error(response?.status + " : " + ErrorMessage.errorDictionary[response?.data?.responseCode]);
          reject(err);
        } else if (err?.code == "E999") {
          reject(err);
        } else {
          forceLogout();
        }
      });
  });
}

export function StolleAPIGet(
  httpGetPath = "",
  configs = {},
  willForceLogout = true,
  domainPath = process.env.REACT_APP_API_DOMAIN
) {
  return new Promise((resolve, reject) => {
    if (!httpGetPath) reject("Invalid Path: " + httpGetPath);
    StolleAxios.get(domainPath + httpGetPath, { ...configs })
      .then((response) => {
        const { responseCode, ...restData } = response.data;

        switch (responseCode) {
          case "E001":
            reject({ code: responseCode });
            forceLogout();
            break;
          default:
            resolve({ code: responseCode, data: restData });
        }
      })
      .catch((err) => {
        console.log({ ...err });
        const { response } = err;

        if (!!response) {
          message.error(response?.status + " : " + ErrorMessage.errorDictionary[response?.data?.responseCode]);
          reject(err);
        } else {
          // message.error(err?.message);
          if (willForceLogout) forceLogout();
          else reject(err);
        }
      });
  });
}

export const forceLogout = () => {
  // message.error("Token Expired: Please Login Again.");
  Swal.fire({
    icon: "warning",
    title: "Please Login Again.",
    html: "This account is signed in on other devices or session expires.",
    allowOutsideClick: false,
    toast: true,
    width: "500px",
    position: "top-end",
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
    didClose: () => {
      store.dispatch(logout());
    },
  });
};

export function getLoginToken() {
  const accessToken = localStorage.getItem("accessToken");
  return accessToken;
}

export class ErrorMessage {
  static errorDictionary = {
    S001: "Success",
    E001: "Someone has login this account, you will be log out.",
    E002: "Modify fail.",
    E003: "Save fail.",
    E004: "Search fail.",
    E005: "Account has been banned.",
    E006: "Request type error.",
    // Login, Regist
    E101: "Account not exist.",
    E102: "Password incorrect.",
    E103: "Member not exsist.",
    E104: "Sponsor verify fail.",
    E105: "Regist fail.",
    E106: "Invalid sign up.",
    E107: "Sending mail fail. Please contact to the company.",
    E108: "Sponsor has no permission to be a root.",
    E109: "This IC card number is banned.",
    E110: "memberID with MX can not create next member",
    E116: "Please double confirm your personal identity card number",
    E117: "Registration is not allowed under the age of 18",
    // Member
    E201: "Member not found.",
    E202: "Can not modify member type.",
    // Order
    E301: "Cancel fail.",
    E302: "Out of date.",
    E303: "Auto Ship Not Active.",
    // AutoShip
    E401: "Auto ship is already exist.",
    // GB Wallet
    E501: "Insufficient balance.",
    E502: "Transfer fail.",
    E503: "Insufficient Point",
    E504: "You can't help Member to make order!",
    // Shopping Center
    E601: "Shopping cart is empty, add some items and try again!",
    E901: "Illegal Operation!",
    E902: "This special offer is limited to 1 set!",
    E903: "If you choose MP-100, you cannot add others product together.",
    E904: "If you want to select MP-100, please empty the shopping cart",
    E905: "If you choose EP-200, you cannot add others product together.",
    E906: "If you want to select EP-200, please empty the shopping cart",
    E907: "Join as Member needs at least 60BV for their first order!",
  };
}
